/**
 * 확정 검토(구 PROVE) 탭 표시 여부 — 2026-09-14 사용자 결정 "우선 안 보이게 가려 두자".
 *
 * 탭이 고유하게 하는 일(문서 사실 추출·PROVED 판정·근거 그래프·검토보고서·서버 저장)은 살아 있고,
 * 딥링크 `?tab=ai`(사이드바 최근 검토가 여는 주소)나 `localStorage loginhs:verdict-tab=1` 로 다시 보인다.
 * 기본은 숨김 — 일상 사용은 사전 점검 카드와 대화 열이 맡는다.
 */
export const VERDICT_TAB_KEY = "loginhs:verdict-tab";
/** LLM 두 모델 지도(Gemini+Opus 교차 출력) — 2026-09-14 사용자 결정 "아직은 공개하기가 좀 그렇다": 기본 숨김.
 *  버튼·자동 실행·패널이 모두 이 플래그를 따른다. `localStorage loginhs:llm-map=1` 로 다시 켠다(종량제 호출). */
export const LLM_MAP_KEY = "loginhs:llm-map";
export function isLlmMapVisible() {
  try { return window.localStorage.getItem(LLM_MAP_KEY) === "1"; } catch (_) { return false; }
}

export function isVerdictTabVisible() {
  try {
    if (new URL(window.location.href).searchParams.get("tab") === "ai") return true;
  } catch (_) { /* window 없음 */ }
  try {
    return window.localStorage.getItem(VERDICT_TAB_KEY) === "1";
  } catch (_) {
    return false;
  }
}
